import { render, staticRenderFns } from "./adminVideoBearbeiten.vue?vue&type=template&id=7633b223&scoped=true"
import script from "./adminVideoBearbeiten.vue?vue&type=script&lang=js"
export * from "./adminVideoBearbeiten.vue?vue&type=script&lang=js"
import style0 from "./adminVideoBearbeiten.vue?vue&type=style&index=0&id=7633b223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633b223",
  null
  
)

export default component.exports